import React from "react";
import "./EventSection.css";
import blogImg1 from "../../assets/gallery/1 (11).jpg";


export default function BlogSection() {
  return (
   <section className="blgsec-section" id="events">
  <div className="blgsec-container">
    {/* Left Content */}
    <div className="blgsec-content">
      <div className="blgsec-post" id="event1">
        <img src={blogImg1} alt="Metal Finishing Seminar" className="blgsec-post-img" />
        <div className="blgsec-post-body">
          <p className="blgsec-date">18/10/2024</p>
          <h2 className="blgsec-title">
            Sreenathji Enterprises & MKS Atotech Host Insightful Seminar on Next-Generation Metal Finishing Technologies
          </h2>
          <p className="blgsec-excerpt">
            October 18, 2024, Renaissance — A Day of Learning, Innovation, and Collaboration.
          </p>
          <p className="blgsec-excerpt">
            Sreenathji Enterprises, in collaboration with MKS Atotech, successfully hosted a
            seminar on next-generation metal finishing technologies on the 18th of October
            2024 at the Renaissance. With the theme <strong>"Evolve – Together We Transform"</strong>,
            the event brought together industry leaders, technical experts, and professionals
            from across the metal finishing sector for a full day of knowledge-sharing and
            technological exploration.
          </p>
          <p className="blgsec-excerpt">
            The seminar focused on the future of surface finishing and introduced advancements in key areas such as:
          </p>
          <ul className="blgsec-list custom-list">
            <li>Decorative Finishes</li>
            <li>Plating on Plastics</li>
            <li>Corrosion Resistance Coatings</li>
            <li>Zinc Flake Coatings</li>
            <li>Paint Support Technologies</li>
            <li>Functional Electronic Coatings</li>
            <li>Electroless Nickel</li>
            <li>Hard Chrome Technologies</li>
          </ul>
          <p className="blgsec-excerpt">
            Through insightful sessions and presentations, attendees explored both current
            challenges and innovative solutions in the industry. The event served as a platform
            not only for technical learning but also for networking and collaboration among
            professionals who are shaping the future of surface finishing technologies.
          </p>
          <p className="blgsec-excerpt">
            The energy and enthusiasm throughout the day were palpable, making it a
            memorable occasion and a much-needed reunion of great minds in the industry.
            As Sreenathji Enterprises and MKS Atotech continue to drive innovation, events
            like these play a crucial role in aligning industry stakeholders toward a more
            advanced and sustainable future.
          </p>
          <p className="blgsec-excerpt">
            Stay tuned for more such initiatives as we continue to evolve—together.
          </p>
          <div className="blgsec-meta">
            <span>📍 Renaissance</span>
            <span>💬 0 Comments</span>
          </div>
        </div>
      </div>
    </div>

    {/* Right Sidebar */}
    <aside className="blgsec-sidebar">
      <div className="blgsec-widget">
        <h3 className="blgsec-widget-title">Recent Industry Events & Exhibitions</h3>
        <ul className="blgsec-recent">
          <li>
            <a href="#event1">Metal Finishing Seminar – Oct 2024</a>
          </li>
        </ul>
      </div>
    </aside>
  </div>
</section>

  );
}
